
import React from 'react';
import './splash.css';
import { connect } from 'react-redux';
import {withRouter} from 'react-router-dom'
import {userToken,setUser} from '../../redux/actions/AuthActions'
import  allStrings from '../../assets/strings'
import {ChangeLanguage} from '../../redux/actions/LanguageAction'
import {Collapsed} from '../../redux/actions/MenuAction'

class Splash extends React.Component {

    state = {
      loading: true,
    };
    

    constructor(props){
      super(props)
      if(this.props.isRTL){
        allStrings.setLanguage('ar')
      }else{
        allStrings.setLanguage('en')
      }
    }

    checkToken =  (token) => {
      const t = localStorage.getItem('@USER-BYIT-ADMIN')
        if(t){
            this.props.userToken(t);
        }else{
          localStorage.setItem('@USER-BYIT-ADMIN-TOKEN',token)
            this.props.userToken(token)
        }
        console.log(token)
    }

    checkLogin =  () => {      
      const userJSON = localStorage.getItem('@USER-BYIT-ADMIN');
      if(userJSON){
          const userInfo = JSON.parse(userJSON);
          console.log(userInfo)
          if(userInfo.user.type !=="ADMIN"){
            if(this.props.history.location.pathname != '/'){
              let data = this.props.location.state?this.props.location.state.data:null
              this.props.history.push(this.props.history.location.pathname,{data:data})
            }else{
              this.props.history.replace('Home') 
            }
          }else{
            console.log(this.props.history)
            if(this.props.history.location.pathname != '/'){
              let data = this.props.location.state?this.props.location.state.data:null
              this.props.history.push(this.props.history.location.pathname,{data:data})
            }else{
              this.props.history.replace('Home') 
            }
          }
        }else{
          this.props.history.push('/Login')
        }
    }

    checkLanguage =  () => {      
    const lang = localStorage.getItem('@LANG');
    if(lang){
          allStrings.setLanguage(lang) 
          if(lang==='ar'){
          this.props.ChangeLanguage(true)  
          }else{
          this.props.ChangeLanguage(false)
          }
        
      }else{
        allStrings.setLanguage('ar') 
        this.props.ChangeLanguage(true)  
      }
    }
    checkMenu =  () => {      
      const menu = localStorage.getItem('@MENU');
      if(menu){
            if(menu==='true'){
            this.props.Collapsed(true)  
            }else{
            this.props.Collapsed(false)
            }
          
        }else{
          this.props.Collapsed(true)  
        }
    }
        


    
    componentDidMount(){
      this.checkLanguage()
      this.checkMenu()
      this.checkLogin()
      // setTimeout(()=>{this.checkLogin()},5000)
    }
     
    
    render() {
      return (
        <div className="splash">
          <div className="overlay" />
          <div className="splash-content">
            <img 
              src={require('../../assets/images/logo.png')} 
              alt="logo"
              className="splash-logo"
            />
            <h2 className="splash-text">Welcome In Byit</h2>
          </div>
        </div>
      );
    }
  }

  
  const mapToStateProps = state => ({
    isRTL: state.lang.isRTL,
  })
  
  const mapDispatchToProps = {
    userToken,
    setUser,
    ChangeLanguage,
    Collapsed
  }

  export default  withRouter(connect(mapToStateProps,mapDispatchToProps)(Splash));

